import namespace from '@/store/namespace'
export default namespace('SolicitudCredenciales', {
  getters: [
    'GetDatosSin',
    'GetDatosRepresentante',
    'GetValidacionSegip',
    'GetValidacionEnCurso',
    'GetFormularioEnviado',
    'GetDatosGuardados',
    'GetDocumentosCredenciales',
    'GetDocumentosCargados',
    'GetEditando',
  ],
  actions: [
    'BuscarYRegistrarDatosSin',
    'ValidarDatosRepresentante',
    'EnvioDeSolicitud',
    'RecuperarDatosGuardados',
    'ListaDocumentosCredenciales',
    'SubirDocumentosCredenciales',
    'EliminarDocumentoCredenciales',
    'EnviarSolicitud',
    'GenerarFormularioR_0530',
    'ObtenerDocumentoAdjunto',
    'LimpiarBusquedaNit'
  ],
  mutations: [
    'SetDatosSin',
    'SetDatosRepresentante',
    'SetValidacionEnCurso',
    'SetValidacionSegip',
    'SetFormularioEnviado',
    'SetDatosGuardados',
    'SetDocumentosCredenciales',
    'SetDocumentosCargados',
    'SetEditando',
  ]
})
